export const combineFiles = ({ files, fileUrls }) =>
  files.map((file) => {
    const fileUrl = fileUrls.find(
      ({ filename }) => filename === file.name
    )?.link

    return {
      ...file,
      fileUrl,
    }
  })

export const sortFiles = (files) =>
  [...files].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

export const createCustomEntityId = (entity) =>
  `${entity.__typename}-${entity.rid}-${entity.borrowerType}`

export const parseCustomEntityId = (customId) => {
  const [entityType, id, borrowerType] = customId.split('-')

  return { entityType, entityId: parseInt(id, 10), borrowerType }
}

export const shouldPreventManualFileCreation = (document) => {
  const DOCS_TO_PREVENT_MANUAL_CREATION = [
    'Document::ExperianCreditData',
    'Document::ExperianCreditDataSoft',
  ]

  return (
    !document.live || DOCS_TO_PREVENT_MANUAL_CREATION.includes(document.type)
  )
}
